import client from "./axios";

const MAIL_BASE_URL = `${process.env.REACT_APP_ENDPOINT_URL}/email`;

export interface SendEmailBody {
  email: string;
  fullName: string;
  phoneNumber: string;
  message: string;
}

export const Mail = {
  sendEmail: (body: SendEmailBody) =>
    client.post(`${MAIL_BASE_URL}/send`, body),
};
